// import SectionContainer from 'components/SectionContainer';
import Contact from 'components/Contact';
import ExpertAdvice from 'components/ExpertAdvice';
import Extras from 'components/Extras';
import { Hero } from 'components/Hero';
import Principles from 'components/Principles';
import Projects from 'components/Projects';
import Stages from 'components/Stages';
import VkBlock from 'components/VkBlock';
import useWindowPositionTop from 'hooks/useWindowPositionTop';
export default function HomePage () {
    useWindowPositionTop();
    return (
        <main id='main' className='main page'>
            {/* <SectionContainer id={'offer'} container={'flex column col-center gap2'}>
                <h1 className="offer__title animation">Веб-разработка нового поколения:</h1>
                <h2 className="offer__subtitle animation">Одностраничное приложение {'(SPA)'}!</h2>
            </SectionContainer> */}
            <Hero />
            <ExpertAdvice/>
            <Stages/>
            <Projects />
            <Principles/>
            <Extras/>
            <Contact />
            <VkBlock/>
        </main>
    )
}

